var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeBgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 577,
    height: 240,
    viewBox: "0 0 577 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M149.449 115.99L186.939 180.621H111.939L149.449 115.99Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.34 180.999L74.8496 116.379H149.85L112.34 180.999Z",
    fill: "#007CB3",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M223.66 115.99L261.16 180.621H186.16L223.66 115.99Z",
    fill: "#007CBE",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.1309 178.63L1.63086 114H76.6309L39.1309 178.63Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.17 180.581L373.66 245.161H298.66L336.17 180.581Z",
    fill: "#007CBE",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M149.451 243.26L111.961 178.63H186.961L149.451 243.26Z",
    fill: "#007CBE",
    fillOpacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M187.561 179.914L225.061 244.544H150.061L187.561 179.914Z",
    fill: "black",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M74.73 245.26L37.25 180.64H112.25L74.73 245.26Z",
    fill: "#007CBE",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.34 180.242L149.84 244.872H74.8398L112.34 180.242Z",
    fill: "#007CBE",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M261.77 180.242L224.25 244.872H299.25L261.77 180.242Z",
    fill: "black",
    fillOpacity: 0.16
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M447.551 173.01L410.061 108.379L485.061 108.379L447.551 173.01Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M484.66 108.001L522.15 172.621L447.15 172.621L484.66 108.001Z",
    fill: "#007CB3",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.34 173.01L335.84 108.379L410.84 108.379L373.34 173.01Z",
    fill: "#007CBE",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M597 43.5206L522 43.9585L559.13 -20.8507L597 43.5206Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M557.869 110.37L595.369 175L520.369 175L557.869 110.37Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.83 108.419L223.34 43.8391L298.34 43.8391L260.83 108.419Z",
    fill: "#007CBE",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M447.549 45.7398L485.039 110.37L410.039 110.37L447.549 45.7398Z",
    fill: "#007CBE",
    fillOpacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M409.439 109.086L371.939 44.4562L446.939 44.4562L409.439 109.086Z",
    fill: "black",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M522.27 43.7395L559.75 108.36L484.75 108.36L522.27 43.7395Z",
    fill: "#007CBE",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M484.66 108.758L447.16 44.1277L522.16 44.1277L484.66 108.758Z",
    fill: "#007CBE",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M261 -20.9999L223.5 43.6301L298.5 43.6301L261 -20.9999Z",
    fill: "#007CBE",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.94 44.3467L335.43 -20.2833L260.43 -20.2833L297.94 44.3467Z",
    fill: "#007CBE",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M335.23 -20.5023L297.75 44.1277L372.75 44.1277L335.23 -20.5023Z",
    fill: "white",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M372.67 44.8342L410.16 -19.7958L335.16 -19.7958L372.67 44.8342Z",
    fill: "#007CBE",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M484.33 -20.164L446.84 44.4661L521.84 44.4661L484.33 -20.164Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M521.75 44.5059L559.24 -20.1242L484.24 -20.1242L521.75 44.5059Z",
    fill: "#007CBE",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M335.23 108.758L372.75 44.1277L297.75 44.1277L335.23 108.758Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M410.109 -20.0048L372.619 44.6253L447.619 44.6252L410.109 -20.0048Z",
    fill: "#007CBE",
    fillOpacity: 0.55
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409,
    height: 126,
    fill: "white",
    transform: "translate(0 114)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 175,
    fill: "white",
    transform: "translate(577 175) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBgIcon);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };